// extracted by mini-css-extract-plugin
export default {"userSettings":"rZT2PD","userSettings__navs":"lotuFe","userSettings__navsHeader":"qUxbhM","nav":"PA6xf0","active":"rlFOCL","userSettings__content":"mEjODZ","has-nav-bar":"YzUp53"};